import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faTimes } from '@fortawesome/free-solid-svg-icons';

interface AgentMessageModalProps {
  show: boolean;
  onHide: () => void;
  agentName: string;
  onSend: (message: string) => void;
  message: string;
  setMessage: (message: string) => void;
}

const AgentMessageModal: React.FC<AgentMessageModalProps> = ({
  show,
  onHide,
  agentName,
  onSend,
  message,
  setMessage
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      onSend(message);
      setMessage('');
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className="bg-dark text-white">
        <Modal.Title className="d-flex align-items-center">
          <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
          Send Message to {agentName}
        </Modal.Title>
        <Button 
          variant="link" 
          onClick={onHide}
          className="text-white p-0"
        >
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Your Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Hi, I'd like to schedule a tour for..."
              autoFocus
            />
            <Form.Text className="text-muted">
              Your agent will receive this message immediately and respond within the hour.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            type="submit"
            disabled={!message.trim()}
          >
            <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
            Send Message
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AgentMessageModal;